export const i18n = {
  defaultLocale: 'ar',
  locales: ['ar', 'en'],
  langDirection: {
    en: 'ltr',
    ar: 'rtl'
  }
}
